import { AddServiceDto } from "./add/mobileView";
import * as Yup from "yup";

export type ServiceDto = AddServiceDto & {
  isReserved?: boolean;
  isSelected?: boolean;
  appointmentDate?: string;
  startTime?: string;
  endTime?: string;
  appointmentId?: number;
  hasPayment?: boolean;
  paymentPrice?: number;
};

export const schema = Yup.object().shape({
  percentage: Yup.string()
    // No commission is a valid choice: 0 to 100.
    .test(
      "between-zero-and-hundred",
      "درصد کمیسیون باید بین ۰ تا ۱۰۰ باشد",
      (value) => Number(value) >= 0 && Number(value) <= 100,
    )
    .required("مقدار درصد را وارد نمایید"),
  price: Yup.string().required("مبلغ اجباری می باشد"),
});
